import * as React from 'react';
import { Title, usePermissions } from 'react-admin';
import { Card, CardContent, Button, Box, Typography } from '@mui/material';
import { useTermsAgreement } from '../common_modules/hooks/TermsAgreementContext';

/**
 * 利用規約・契約内容確認ページ
 */
export const ContractPage = () => {
  const { showDialog } = useTermsAgreement();
  const { permissions } = usePermissions();

  return (
    <Card sx={{ mt: 2 }}>
      <Title title="利用規約" />
      <CardContent>
        <Typography variant="body1" gutterBottom>
          successfee利用規約の確認ができます。
        </Typography>
        <Typography variant="body1" gutterBottom>
          下記のボタンをクリックして内容をご確認ください。
        </Typography>
        <Box sx={{ mt: 6, display: 'flex', gap: 2 }}>
          <Button variant="outlined" onClick={() => showDialog('terms')}>
            利用規約
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};
